// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { UserServiceRequest } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { CreateEvent } from '@daml/ledger';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useCreateUserServiceRequest: () => UseMutationResult<
  CreateEvent<UserServiceRequest>,
  string,
  { operator: string; party: string }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['createUserServiceRequest', ledgerApi],
    mutationFn: async ({ operator, party }) => {
      return ledgerApi.createCredentialUserServiceRequest(operator, party);
    },
  });
};

export default useCreateUserServiceRequest;
